import { createSignal, onCleanup } from "solid-js";

export function useTimestampInSeconds(interval = 1000) {
  const [timestamp, setTimestamp] = createSignal(Math.floor(Date.now() / 1000));

  const timer = setInterval(() => {
    setTimestamp(Math.floor(Date.now() / 1000));
  }, interval);

  onCleanup(() => clearInterval(timer));

  return timestamp;
}
